import { render, staticRenderFns } from "./IMOEditor.vue?vue&type=template&id=f352ad3e&scoped=true&"
import script from "./IMOEditor.vue?vue&type=script&lang=ts&"
export * from "./IMOEditor.vue?vue&type=script&lang=ts&"
import style0 from "./IMOEditor.vue?vue&type=style&index=0&id=f352ad3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f352ad3e",
  null
  
)

export default component.exports